import { v4 as uuid } from 'uuid';

export const CMS_MERIT_PROMOTION_TABLE_CONTENT = `
<table id="${uuid()}" class="merit-letter-table-element">
  <tbody>
    <tr class="header">
      <th></th>
      <th>{meritPromotionTablePreviousTitle}</th>
      <th>{meritPromotionTableCurrentTitle}</th>
    </tr>
    <tr>
      <td>{meritPromotionTableJobTitleLabel}</td>
      <td>{merit_prevJobTitle}</td>
      <td>{merit_currentJobTitle}</td>
    </tr>
    <tr>
      <td>{meritPromotionTablePositionClassLabel}</td>
      <td>{merit_prevMercerPC}</td>
      <td>{merit_currentMercerPC}</td>
    </tr>
  </tbody>
</table>
`;
